export default __webpack_public_path__ + "static/media/YAS0650.34I-31166_-17717_0.75081774.jpg";